module.exports = __webpack_public_path__ + "static/media/logo-wap.a591030a.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/page_app_solution/logo-wap.png
// module id = 525
// module chunks = 0